import { z } from 'zod';
export default {
  createFor(name, objectType, {
    isArray = false,
    molten
  }) {
    molten.addPlugin('AttributeValueValidator', {
      name,
      objectType,
      valueValidator: isArray ? z.array(z.string().email()).optional().nullable() : z.string().email().optional().nullable()
    });
  }
};